import React, { Component } from "react";
import Titulo from "../../../generico/TituloPagina";
import DatosSocio from "../../../generico/DatosSocio"
import Switch from "react-switch";
import { formatoSeparadorMilesValue } from "../../../generico/utils/FormatoInput";
import { trackPromise } from "react-promise-tracker";
import $ from "jquery"
import Popup from "react-popup";
import history from "../../login/history";
import TecladoPin from "../../../generico/TecladoPin";
import TarjetaService from "../../../../services/pagos/TarjetaService";
import { ESTADO_TARJETA, MENSAJE, OPERACION_TARJETA } from "../../../generico/utils/Constantes";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowCircleUp} from "@fortawesome/free-solid-svg-icons";
import MensajeUsuario from "../../../generico/MensajeUsuario";


const PIN_LENGTH = 4;


const SwitchTarjetaCretido = ({ tarjetaSeleccionada, estadoSwitch, onChangeEstadoTarjeta }) => {

  const handleChangeTarjetaEstado = (e) => {
    onChangeEstadoTarjeta(e);
  }

  return (
    <div className="container">
    <div className="row card-tarjeta">
      <div className="col-md-8">
          <div className="col-md-12 col-lg-4" style={{ fontWeight: 500 }}>
            <div className="tarjeta-imagen">
              <img src={tarjetaSeleccionada?.tarjetaURL} className="img-tarjeta w-100" alt="Imagen de la Tarjeta" /*width="200px" height="100%"*/ />
            </div>
          </div>
          <div className="col-md-12 col-lg-8" style={{ fontWeight: 500 }}>
              <div className="col-md-12" style={{ fontWeight: 500 }}>
                <span className="dato" style={{ fontWeight: 600, fontSize: 20 }}>{tarjetaSeleccionada?.tipo}</span>
              </div>
              <div className="col-md-12">
                <span className="dato">Línea: <b className="input-label-bold">{tarjetaSeleccionada?.linea}</b></span>
              </div>

          </div>
      </div>
      <div className="col-12 col-md-4">
        <div className="align-items-center">
          <div className="row" style={{ paddingTop: 0 }}>
            <div className="col-md-10 col-12">
              <div className="border-aviso">
                  <div className="col-md-12">
                    <h5 style={{ fontSize: "18px" }}>Aviso</h5>
                  </div>
                  <div className="col-md-12" style={{ fontSize: "15px" }}>
                    <b>Apagado:</b>  bloquea la tarjeta.
                  </div>
                  <div className="col-md-12" style={{fontSize: "15px" }}>
                    <b>Encendido:</b> desbloquea la tarjeta.
                  </div>
              </div>
             
            </div>
          <div className="col-md-10" style={{display:"grid", justifyContent:"center", textAlign:"center" }}>
            
            <span className="input-label text-apagado-encendido mr-3">Apagado/Encendido </span>
            <Switch id="apagar-tarjeta"
              onChange={handleChangeTarjetaEstado}
              checked={estadoSwitch}
              className="react-switch"
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              onColor="#EAAC24" />

            </div>
          </div>
        </div>
      </div>
    </div>
    </div>

  )

}

const BotonGuardar = ({ children, disabled, onClick }) => {

  const handleOnClick = (e) => {
    onClick(e);
  }

  return (
    <button
      type="submit"
      className="btn btn-cu-primary float-right"
      disabled={disabled}
      onClick={handleOnClick}
    >
      {children}
    </button>
  )
}

export default class ConfigurarTarjetaCabal extends Component {

  constructor(props) {
    super(props);

    this.state = this.getInitialState();
    this.nuevoPinRef = React.createRef();
    this.confirmarPinRef = React.createRef();

    this.onChangeEstadoTarjeta = this.onChangeEstadoTarjeta.bind(this);
    this.confirmarCambioEstadoTarjeta = this.confirmarCambioEstadoTarjeta.bind(this);

  }

  getInitialState = () => {

    let tarjetaSeleccionada = JSON.parse(sessionStorage.getItem("tarjetaSeleccionada"));

    if (!tarjetaSeleccionada) history.goBack();

    return {
      mostrarFormulario: false,
      changeDataCount: 0,
      originalData: null,
      tarjetaSeleccionada,
      canalList: [],
      rubroList: [],
      paisList: [],
      paisesAdicionales: [],
      tarjetaEstado: "",
      bloquearDesbloquearTarjeta: "",
      activarInactivarTarjeta: "",
      limiteDiario: null,
      limiteMensual: null,
      infoTarjeta: null,
      pinNuevo: "",
      pinNuevoConfirmar: ""
    }
  };

  resetState = () => {
    $(".change-value").removeClass("change-value");
    this.setState(this.getInitialState()
    );
  }

  componentDidMount() {

    let tarjetaSeleccionada = JSON.parse(sessionStorage.getItem("tarjetaSeleccionada"));
    this.setState({ tarjetaSeleccionada });

    if (tarjetaSeleccionada?.tipoDesc === "Master") {
      $("input").attr("disabled", true);
      $("[name=btn-agregar-paises]").attr("disabled", true);
      this.obtenerParametrosTarjeta();
    } else {
      this.getInfoTarjeta();
    }

  }

  componentDidUpdate() {

    if (this.state.bloquearDesbloquearTarjeta !== "") this.bloqueoDesbloqueoTarjeta()
    if (this.state.activarInactivarTarjeta !== "") this.cargarParametrosTarjeta();

  }

  notifiPopup = (titulo, mensaje, callback = undefined) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              callback && callback();
              Popup.close();
            },
          },
        ],
      },
    });

  notifiPopupConfirmar = (titulo, mensaje, callback) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Cancelar",
            className: "secundary",
            action: function () {
              Popup.close();
            },
          },
          {
            text: "Continuar",
            className: "success",
            action: function () {
              callback && callback();
              Popup.close();
            },
          },
        ],
        left: [],
      },

    });


  getInfoTarjeta = () => {
    trackPromise(
      TarjetaService.getInfoTarjeta()
        .then(response => {

          let { tarjetaSeleccionada } = this.state;
          let { data, header } = response.data;

          if (header.codReturn === "0") {

            if (data.length === 0) {
              Popup.queue(this.notifiPopup("Info", MENSAJE.ERROR_INESPERADO, history.goBack));
              return null;
            }

            let infoTarjeta = data.find(element => element.NUMERO_TARJETA === tarjetaSeleccionada.nroTarjetaCompleto);
            let initialState = this.getInitialState();
            this.setState({ ...initialState, infoTarjeta, tarjetaEstado: infoTarjeta.ESTADO });

          } else {
            Popup.queue(this.notifiPopup("Info", data.txtReturn, history.goBack));
          }

        })
        .catch(error => {
          console.log(error);
          Popup.queue(this.notifiPopup("Info", MENSAJE.ERROR_INESPERADO, history.goBack));
        })
    )
  }

  confirmarCambioEstadoTarjeta(operacion) {

    let { tarjetaSeleccionada } = this.state;

    let accion = tarjetaSeleccionada.tipoDesc === "Master"
      ? operacion ? "activada" : "desactivada"
      : operacion ? "desbloqueada" : "bloqueada"

    Popup.queue(
      this.notifiPopupConfirmar(
        "Atención",
        `La Tarjeta será ${accion}, ¿Está seguro que desea continuar?`,
        () => this.onChangeEstadoTarjeta(operacion, tarjetaSeleccionada.tipoDesc)
      )
    );

  }

  /**
   * apagado/encendido tarjeta
   */

  onChangeEstadoTarjeta(estadoNuevo, tipoTarjeta) {

    if (tipoTarjeta === "Master") {

      let { activarInactivarTarjeta } = this.state;

      estadoNuevo = estadoNuevo ? ESTADO_TARJETA.MASTER.ACTIVO : ESTADO_TARJETA.MASTER.INACTIVO;
      activarInactivarTarjeta = estadoNuevo;

      let disableInput = estadoNuevo === ESTADO_TARJETA.MASTER.ACTIVO ? false : true;

      this.setState({ tarjetaEstado: estadoNuevo, activarInactivarTarjeta });

      $("input").attr("disabled", disableInput);
      $("[name=btn-agregar-paises]").attr("disabled", disableInput);

    } else {

      let { bloquearDesbloquearTarjeta } = this.state;
      bloquearDesbloquearTarjeta = estadoNuevo ? OPERACION_TARJETA.CABAL.DESBLOQUEAR : OPERACION_TARJETA.CABAL.BLOQUEAR;
      estadoNuevo = estadoNuevo ? ESTADO_TARJETA.CABAL.ACTIVO : ESTADO_TARJETA.CABAL.BLOQUEADO;
      this.setState({ tarjetaEstado: estadoNuevo, bloquearDesbloquearTarjeta });

    }

  }

  bloqueoDesbloqueoTarjeta = () => {

    let { infoTarjeta, bloquearDesbloquearTarjeta } = this.state;

    let paramData = {
      numeroTarjeta: infoTarjeta.NUMERO_TARJETA,
      tipoOperacion: bloquearDesbloquearTarjeta
    }

    trackPromise(
      TarjetaService.bloqueoDesbloqueoTarjeta(paramData)
        .then(response => {
          let { data, header } = response.data;
          Popup.queue(this.notifiPopup("Info", header.txtReturn, () => {
            this.setState({ bloquearDesbloquearTarjeta: "" });
          }));
        })
        .catch(error => {
          console.log(error);
          Popup.queue(this.notifiPopup("Info", MENSAJE.ERROR_INESPERADO, () => {
            this.getInfoTarjeta();
          }));
        })
    )
  }


  pinNewValue = (pinNuevo) => {
    this.setState({ pinNuevo });
  }

  pinConfValue = (pinNuevoConfirmar) => {
    this.setState({ pinNuevoConfirmar });
  }

  cambioDePin = () => {
    let { infoTarjeta, pinNuevo, pinNuevoConfirmar } = this.state;

    if (pinNuevo !== pinNuevoConfirmar) {
      Popup.queue(this.notifiPopup("Error", MENSAJE.ERROR_PIN_DIFERENTE, () => {
        this.nuevoPinRef.limpiarPin();
        this.confirmarPinRef.limpiarPin();
      }));
      return null;
    }

    trackPromise(
      TarjetaService.cambioDePin(infoTarjeta.NUMERO_TARJETA, pinNuevo)
        .then(response => {
          let { data, header } = response.data;

          Popup.queue(this.notifiPopup("Info", header.txtReturn, () => {
            this.nuevoPinRef.limpiarPin();
            this.confirmarPinRef.limpiarPin();
          }));

        })
        .catch(error => {
          console.log(error);
          Popup.queue(this.notifiPopup("Error", MENSAJE.ERROR_INESPERADO));
        })
    )
  }

  formatoMontoLimite = (value) => {
    if (value === null || value === "") return "";
    return formatoSeparadorMilesValue(value);
  }

  render() {

    let {
      canalList,
      rubroList,
      paisList,
      changeDataCount,
      tarjetaSeleccionada,
      tarjetaEstado,
      limiteDiario,
      limiteMensual,
      pinNuevo,
      pinNuevoConfirmar
    } = this.state;

    let disabledBtnGuardar = tarjetaSeleccionada.tipoDesc === "Master"
      ? changeDataCount === 0
      : !(pinNuevo.length === PIN_LENGTH && pinNuevoConfirmar.length === PIN_LENGTH)

    let estadoSwitchTarjeta = tarjetaSeleccionada.tipoDesc === "Master"
      ? tarjetaEstado === ESTADO_TARJETA.MASTER.ACTIVO ? true : false
      : tarjetaEstado === ESTADO_TARJETA.CABAL.ACTIVO ? true : false

    return (
      <div className="content-wrapper">
        <Titulo texto="Configuración de Tarjeta" />
        <section className="content">
          <div className="container config-tarjeta">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <DatosSocio />
                  </div>
                  <div className="card-body">
                    <SwitchTarjetaCretido
                      tarjetaSeleccionada={tarjetaSeleccionada}
                      estadoSwitch={estadoSwitchTarjeta}
                      onChangeEstadoTarjeta={this.confirmarCambioEstadoTarjeta}
                    />
                    <br />
                    <MensajeUsuario tipo="INFO"
                      titulo="Importante."
                      mensaje={<p className="pr-5">Si bloquea su tarjeta en forma definitiva ya sea por robo o extravío y desea una regrabación, deberá ponerse en comunicación con el CAS al 617 0000 para solicitarla.</p>}
                    />
                    <hr />
                    {
                      estadoSwitchTarjeta &&
                      <div>
                        <h4 style={{color: '#1A9185', margin:"1rem"}}>Cambio de PIN Tarjetas</h4>
                        <div className="row">
                          <div className="col-md-12 col-lg-6">
                            <div className="callout callout-warning consideraciones mr-2" style={{lineHeight:"1.8rem"}}>
                              <h5>Consideraciones</h5>
                              <p>Recuerde que su PIN es exclusivamente para su uso personal y que sustituye a su firma, siendo de su entera responsabilidad el uso del mismo. No lo divulgue ni lo escriba. No elija un PIN que sea fácil de deducir por terceros (ej. año nacimiento). La Universitaria Ltda. se exime de toda responsabilidad y/o reclamo que pudiera surgir eventualmente por las operaciones realizadas a través de su PIN.</p>
                            </div>
                          </div>
                          <div className="col-md-12 col-lg-6">
                            <div className="row">
                              <div className="col-md-6 d-flex my-2 justify-content-center">
                                <TecladoPin
                                  ref={ref => this.nuevoPinRef = ref}
                                  pinValue={this.pinNewValue}
                                  label={`Nuevo Pin (${PIN_LENGTH} dígitos) *`}
                                  pinLength={PIN_LENGTH}
                                />
                              </div>
                              <div className="col-md-6 d-flex my-2 justify-content-center">
                                <TecladoPin
                                  ref={ref => this.confirmarPinRef = ref}
                                  pinValue={this.pinConfValue}
                                  label={`Confirmar Pin (${PIN_LENGTH} dígitos) *`}
                                  pinLength={PIN_LENGTH}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <div className="card-footer">
                    <div className="col-lg-2 col-md-5 float-right">
                    {
                      estadoSwitchTarjeta &&
                      <BotonGuardar
                        disabled={disabledBtnGuardar}
                        onClick={this.cambioDePin}
                      >
                      <FontAwesomeIcon icon={faArrowCircleUp} />  Cambiar PIN
                      </BotonGuardar>
                    }
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section >
      </div >
    );
  }
}